import type { CountryCode } from 'libphonenumber-js'

/** Countries Brighterly does not hire tutors from. */
export const APP_PHONE_IGNORED_COUNTRIES: CountryCode[] = [
  'FK', 'EC', 'CL', 'UY', 'SR', 'PE', 'PY', 'CO', 'GY', 'VE', 'BR', 'BO', 'AR',
  'SS', 'ET', 'ER', 'TD', 'UG', 'TG', 'TZ', 'SL', 'SD', 'SO', 'SN', 'EH', 'RW',
  'NE', 'MZ', 'MA', 'MR', 'LY', 'LR', 'CI', 'CG', 'KE', 'CM', 'ZW', 'ZM', 'GW',
  'GH', 'BW', 'AO', 'DZ', 'FJ', 'UZ', 'KZ', 'RU', 'AF', 'PK', 'IN', 'MG',
]

export const APP_PHONE_PREFERRED_COUNTRIES: CountryCode[] = ['PH', 'US', 'GB']

export const APP_PHONE_DEFAULT_COUNTRY: CountryCode = 'PH'
